/**
 * ddsClient.js — module-scope @aelive/dds-client singleton.
 *
 * Mirrors Broker/lib/dds.js so the data shapes Dashboard's form
 * library resolves against are identical to what the broker uses on
 * its server-side bind path.
 *
 * Singleton because:
 *   - DDS client holds HTTP + WS connections; one per page is plenty.
 *   - Identity stability matters for useFixtureContext's source-dep
 *     useMemo — recreating the client every render would rebuild the
 *     entire data service stack.
 */
import { createDDSClient } from "@aelive/dds-client";

let _client = null;

export function getDDSClient() {
  if (_client) return _client;
  _client = createDDSClient({
    http: { url: process.env.REACT_APP_DDS_HTTP_URL },
    ws: { url: process.env.REACT_APP_DDS_WS_URL },
  });
  return _client;
}
